import InputAdornment from '@material-ui/core/InputAdornment'
import TextField from '@material-ui/core/TextField'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import ExpandableListElement from '../../components/controls/ExpandableListElement'
import LabelCheckbox from '../../components/controls/LabelCheckbox'
import Szambelan from '../../components/Szambelan'
import { controlHasError } from '../../lib/errorHandler'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'
import WykazJednostekSkonsolidowaneStyle from '../../styles/WykazJednostekSkonsolidowaneStyle'
import logo from '../../assets/images/szambelan_jednostki.svg'
import PrintText from '../../lib/PrintText'

class WykazJednostekObjetychSprFin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: -1,
      udzial: props.section.Dane.Pozycje.map(
        (x) => x.UdzialJednDominujacejWKapitale !== x.UdzialWLiczbieGlosow,
      ),
    }
  }

  handleToggleActive = (index) => {
    this.setState({ activeIndex: index })
  }

  handleUdzialChange = (e, index) => {
    let x = [...this.state.udzial]
    x[index] = e.target.checked
    this.setState({ udzial: x })
  }

  handleAdd = (structure, sIndex) => {
    this.setState({
      udzial: [...this.state.udzial, false],
    })
    this.props.onAddDetailInfo(structure, sIndex)
  }

  render() {
    const {
      onSetSectionDataArray,
      section,
      validityErrors,
      czyPodsumowanie,
    } = this.props
    const struktura = {
      NazwaSiedziba: '',
      PrzedmiotDzialalnosci: '',
      UdzialJednDominujacejWKapitale: 0,
      UdzialWLiczbieGlosow: 0,
      WzajemnePowiazanieKapitalowe: '',
    }
    return (
      <MainStyle
        className={section.Dane.Pozycje.length > 0 ? '' : 'hide-on-print'}
      >
        <WykazJednostekSkonsolidowaneStyle>
          <div className="site-header high-emphasis-subtitle-1">
            <span>
              WYKAZ JEDNOSTEK ZALEŻNYCH, WSPÓŁZALEŻNYCH I STOWARZYSZONYCH,
              KTÓRYCH DANE
              <br />
              SĄ OBJĘTE SKONSOLIDOWANYM SPRAWOZDANIEM FINANSOWYM
            </span>
            <ButtonAddInfo
              label="DODAJ JEDNOSTKĘ"
              structure={struktura}
              handleAdd={this.handleAdd}
            />
          </div>
          {section.Dane.Pozycje.length > 0 ? (
            <div className="container">
              <div className="list-header caption">
                <p>NAZWA I SIEDZIBA JEDNOSTKI</p>
              </div>
              {section.Dane.Pozycje.map((data, index) => (
                <ExpandableListElement
                  placeholder="Nazwa i siedziba jednostki"
                  nazwaPozycji={data.Nazwa}
                  isActive={this.state.activeIndex === index}
                  key={index}
                  index={index}
                  hasError={(name, value) =>
                    controlHasError(validityErrors, name, value, true)
                  }
                >
                  <div className="header">
                    <p>SZCZEGÓŁY</p>
                  </div>
                  <form autoComplete="off" className="subsection">
                    <TextField
                      className="textarea"
                      name="PrzedmiotDzialalnosci"
                      placeholder="Przedmiot działalności"
                      label="Przedmiot działalności"
                      value={data.PrzedmiotDzialalnosci}
                      error={controlHasError(
                        validityErrors,
                        'PrzedmiotDzialalnosci',
                        data.PrzedmiotDzialalnosci,
                        true,
                      )}
                      onChange={(e) => onSetSectionDataArray(e, index)}
                      onFocus={() => this.handleToggleActive(index)}
                      onBlur={() => this.handleToggleActive(-1)}
                    />
                    <div className="oneLine">
                      <p>
                        Udział jedn. dominującej, wspólnika jedn. współzależnej
                        lub znaczącego inwestora w kapitale (funduszu)
                        podstawowym:
                      </p>
                      <TextField
                        className="numericField"
                        placeholder="Udział"
                        name="UdzialJednDominujacejWKapitale"
                        value={data.UdzialJednDominujacejWKapitale}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">%</InputAdornment>
                          ),
                        }}
                        error={controlHasError(
                          validityErrors,
                          'UdzialJednDominujacejWKapitale',
                          data.UdzialJednDominujacejWKapitale,
                          true,
                        )}
                        onChange={(e) => onSetSectionDataArray(e, index)}
                      />
                    </div>
                    <div className="oneLine">
                      <LabelCheckbox
                        name="CzyUdzialRozny"
                        label="Udział w całkowitej liczbie głosów jest różny od udziału w kapitale (funduszu) podstawowym"
                        value={this.state.udzial[index]}
                        change={(e) => this.handleUdzialChange(e, index)}
                      />
                      {this.state.udzial[index] ? (
                        <>
                          <p>Udział w całkowitej liczbie głosów:</p>
                          <TextField
                            className="numericField"
                            placeholder="Udział"
                            name="UdzialWLiczbieGlosow"
                            value={data.UdzialWLiczbieGlosow}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  %
                                </InputAdornment>
                              ),
                            }}
                            onChange={(e) => onSetSectionDataArray(e, index)}
                          />
                        </>
                      ) : null}
                    </div>
                    {czyPodsumowanie ? (
                      <PrintText
                        text={data.WzajemnePowiazanieKapitalowe}
                      />
                    ) : (
                      <TextField
                        className="textarea"
                        multiline
                        variant="outlined"
                        name="WzajemnePowiazanieKapitalowe"
                        label="Wzajemne powiązania kapitałowe pomiędzy jednostkami objętymi konsolidacją"
                        value={data.WzajemnePowiazanieKapitalowe}
                        error={controlHasError(
                          validityErrors,
                          'WzajemnePowiazanieKapitalowe',
                          data.WzajemnePowiazanieKapitalowe,
                          true,
                        )}
                        onChange={(e) => onSetSectionDataArray(e, index)}
                        onFocus={() => this.handleToggleActive(index)}
                        onBlur={() => this.handleToggleActive(-1)}
                      />
                    )}
                  </form>
                </ExpandableListElement>
              ))}
            </div>
          ) : (
            <Szambelan
              logo={logo}
              text={
                <>
                  Jeszcze nie dodano informacji
                  <br /> o jednostkach zależnych, współzależnych
                  <br /> i stowarzyszonych objętych konsolidacją
                </>
              }
            />
          )}
        </WykazJednostekSkonsolidowaneStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors.filter(
          (value) => value.TypSekcji === 'WykazJednostekObjetychSprFin',
        )
      : [],
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionDataArray: (e, index) => {
      let { value, name } = e.target
      if (
        name === 'UdzialJednDominujacejWKapitale' ||
        name === 'UdzialWLiczbieGlosow'
      )
        value = value.replace(',', '.')
      dispatch(actions.setSectionDataArray(value, index, 0, name))
    },
    onAddDetailInfo: (structure, sIndex) => {
      return dispatch(actions.addDetailInfo(structure, sIndex))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WykazJednostekObjetychSprFin)
